import { TODO } from '@b2b/types/core';
import { StateService } from '@uirouter/angularjs';
import angular, { IScope } from 'angular';

export const TemplatesControllerModule = angular
  .module('acme.view.application.templates.controllers', [])
  .controller('TemplatesController', [
    '$scope',
    '$state',
    function TemplatesController($scope: IScope & { templates: TODO }, $state: StateService) {
      $scope.templates = {
        model: 'Your spankin new application.templates.default view!',

        init: function () {
          $scope.$emit('Application::contentTitleChange', {
            title: 'Event Template',
          });
        },

        success: {
          init: function (response) {},
        },

        error: {
          init: function (response) {},
        },
      };

      $scope.templates.init();
    },
  ]).name;
